module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/880e77250f579beea45557e398c82c23.svg";